<template>
    <div class="full-width">
        <div class="icon-part">
            <el-button type="primary" plain @click="clickAction('editUser')" size="small" :color="'#32c5d2'" class="icon-button"><font-awesome-icon icon="fa-solid fa-pen-to-square" />&nbsp;<span tkey="編輯信息">{{i18n.tkey("lang_edit_information")}}</span></el-button>
        </div>

        <div class="icon-part">
            <el-button type="primary" plain @click="clickAction('editCard')" size="small" :color="'#32c5d2'" class="icon-button"><font-awesome-icon icon="fa-solid fa-wand-magic-sparkles" />&nbsp;<span tkey="更換樣式">{{i18n.tkey("lang_change_style_text")}}</span></el-button>
        </div>

        <div class="icon-part">
            <el-button type="primary" plain @click="clickAction('editNews')" size="small" :color="'#32c5d2'" class="icon-button"><font-awesome-icon icon="fa-solid fa-pager" />&nbsp;<span tkey="公司簡介">{{i18n.tkey("lang_company_detail_1")}}</span></el-button>
        </div>

<!--        <div class="icon-part">-->
<!--            <el-button type="primary" plain @click="clickAction('cardRecord')" size="small" :color="'#32c5d2'" class="icon-button"><font-awesome-icon icon="fa-solid fa-user-plus" />&nbsp;收錄請求</el-button>-->

<!--            <div class="new-memberwork-num-box" v-if="null != countNum">-->
<!--                <span class="new-memberwork-num-text">{{countNum}}</span>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script setup>
    //导入图标
    import {computed, inject} from "vue"
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faUserPlus, faPager, faWandMagicSparkles, faPenToSquare } from '@fortawesome/free-solid-svg-icons'
    import {useChatinfo} from "@/stores/chatinfo";
    import {toRef} from "vue";

    const emits = defineEmits(['clickAction'])

    library.add(faUserPlus, faPager, faWandMagicSparkles, faPenToSquare)

    const i18n = inject("i18n")

    //響應機制的chatinfo
    const chatInfoRef = toRef(useChatinfo())

    const countNum = computed(() => {
        const num = chatInfoRef.value.cardRecordCount

        if (num == 0){
            return null
        }

        if (num > 99){
            return "99+"
        }

        return num
    })

    function clickAction(name) {
        emits("clickAction", name)
    }

</script>

<style scoped>
    .full-width {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }

    .icon-part {
        position: relative;
        margin-bottom: 12px;
    }

    .icon-button {
        margin-left: 1px;
        padding: 8px;
        font-size: 12px;
    }

    .new-memberwork-num-box {
        position: absolute;
        margin-top: -10px;
        margin-right: -16px;
        background-color: #fd3635;
        width: 20px;
        height: 20px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        user-select: none;
        right: 17px;
        top: 0;
    }

    .new-memberwork-num-text {
        color: #FFFFFF;
        font-size: 10px;
    }
</style>